import { render, staticRenderFns } from "./ClippingImage.vue?vue&type=template&id=42206dd4&scoped=true"
import script from "./ClippingImage.vue?vue&type=script&lang=ts"
export * from "./ClippingImage.vue?vue&type=script&lang=ts"
import style0 from "./ClippingImage.vue?vue&type=style&index=0&id=42206dd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42206dd4",
  null
  
)

export default component.exports